import { DEFAULT_LANGUAGE } from 'pages/localization/constants';

import { PREVIEW_USER_DETAILS } from 'components/PreviewScreen/constants';

import { ActionType } from '../actions/preview';
import type { PreviewAction, PreviewState } from '../types/preview';
import type { Language } from '@welltech/wellfunnel/types';

export const initialState = {
    standardPreviewParams: {
        ...PREVIEW_USER_DETAILS,
    },
    rulesBasedPreviewParams: {},
    previewLocalization: DEFAULT_LANGUAGE as Language,
    previewTranslationsObject: {},
    timerValue: '',
};

export const previewReducer = (state: PreviewState, action: PreviewAction): PreviewState => {
    switch (action.type) {
        case ActionType.SET_STANDARD_PREVIEW_PARAMS:
            return { ...state, standardPreviewParams: { ...state.standardPreviewParams, ...action.payload } };
        case ActionType.SET_RULES_BASED_PREVIEW_PARAMS:
            return { ...state, rulesBasedPreviewParams: { ...state.rulesBasedPreviewParams, ...action.payload } };
        case ActionType.SET_PREVIEW_LOCALIZATION:
            return { ...state, previewLocalization: action.payload };
        case ActionType.RESET_PREVIEW_PARAMS:
            return initialState;
        case ActionType.SET_TIMER_VALUE:
            return { ...state, timerValue: action.payload };
        default:
            return state;
    }
};
